import React from 'react';
import {Link} from 'react-router';
import { Dialog } from "@blueprintjs/core";
import {Text} from 'components/tt-forms/common';
import { get } from 'lodash';

class ChiTietDoiTuongThanhTraDialog extends React.Component {
  render() {
    let Data = this.props.data || {};
    let getChiTietMotDoiTuong = null;
    let getChiTietNhieuDoiTuong = [];
    if ((Data.doiTuongThanhTraInfo || Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) && Data.cuocThanhTraNhieuDoiTuong === false) {
      getChiTietMotDoiTuong = Data.doiTuongThanhTraInfo || Data.listDoiTuongThanhTra[0];
    } else if (Data.doiTuongThanhTras && Data.doiTuongThanhTras.length > 0 && Data.cuocThanhTraNhieuDoiTuong === true) {
      getChiTietNhieuDoiTuong = Data.doiTuongThanhTras || [];
    } else if (Data.doiTuongThanhTraInfo && Data.cuocThanhTraNhieuDoiTuong === false) {
      getChiTietMotDoiTuong = Data.doiTuongThanhTraInfo;
    }
    return (
      <Dialog
        isOpen={this.props.open}
        onClose={this.props.onClose}
        title='Thông tin đối tượng thanh tra, kiểm tra'
        className="dialog-default wrap-block"
        >
          {
            getChiTietMotDoiTuong !== null  ? (
              <div className='row pl30 pr30 pt20'>
                <Text
                  className="col-50 mb10"
                  label="Tên đối tượng:"
                  value={getChiTietMotDoiTuong.ten || ''} />
                <Text
                  className="col-50 mb10"
                  label="Nhóm đối tượng:"
                  value={getChiTietMotDoiTuong.nhomDoiTuongThanhTraInfo && getChiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten ? getChiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten :  ''} />
                <Text
                  className="col-50 mb10"
                  label="Huyện/TP:"
                  value={get(getChiTietMotDoiTuong, 'quanHuyenInfo.name')} />
                <Text
                  className="col-50 mb10"
                  label="Phường/Xã:"
                  value={get(getChiTietMotDoiTuong, 'phuongXaInfo.name')} />
                <Text
                  className="col-50 mb10"
                  label="Địa chỉ:"
                  value={getChiTietMotDoiTuong.diaChi || ''} />
                <Text
                  className="col-50 mb10"
                  label="Số điện thoại:"
                  value={getChiTietMotDoiTuong.soDienThoai || ''} />
                <Text
                  className="col-50 mb10"
                  label="Ghi chú:"
                  value={getChiTietMotDoiTuong.ghiChu || ''} />
              </div>
            ) : getChiTietNhieuDoiTuong.length > 0 ?  (
              <table className="blueTable">
                <thead>
                  <tr>
                    <th style={{width: '35px'}}>STT</th>
                    <th style={{width: '300px'}}>Tên đối tượng</th>
                    <th style={{width: '165px'}}>Nhóm đối tượng</th>
                    <th style={{width: '165px'}}>Huyện/TP</th>
                    <th style={{width: '165px'}}>Phường/Xã</th>
                    <th style={{width: '375px'}}>Địa chỉ</th>
                    <th style={{width: '135px'}}>Số điện thoại</th>
                  </tr>
                </thead>
                <tbody>
                  {
                      getChiTietNhieuDoiTuong.map((item,index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.ten}</td>
                                  <td>{item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''}</td>
                                  <td>{get(item, 'quanHuyenInfo.name')}</td>
                                  <td>{get(item, 'phuongXaInfo.name')}</td>
                                  <td>{item.diaChi}</td>
                                  <td>{item.soDienThoai || ''}</td>
                                </tr>
                      ))
                    }
                </tbody>
              </table>
            ) : this.props.data.listDoiTuongThanhTra ? (
              <table className="blueTable">
                <thead>
                  <tr>
                    <th style={{width: '35px'}}>STT</th>
                    <th style={{width: '300px'}}>Tên đối tượng</th>
                    <th style={{width: '165px'}}>Nhóm đối tượng</th>
                    <th style={{width: '165px'}}>Huyện/TP</th>
                    <th style={{width: '165px'}}>Phường/Xã</th>
                    <th style={{width: '375px'}}>Địa chỉ</th>
                    <th style={{width: '135px'}}>Số điện thoại</th>
                  </tr>
                </thead>
                <tbody>
                  {
                      this.props.data.listDoiTuongThanhTra &&
                        this.props.data.listDoiTuongThanhTra.map((item,index) => {
                          return  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.ten}</td>
                                    <td>{item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''}</td>
                                    <td>{get(item, 'quanHuyenInfo.name')}</td>
                                    <td>{get(item, 'phuongXaInfo.name')}</td>
                                    <td>{item.diaChi}</td>
                                    <td>{item.soDienThoai || ''}</td>
                                  </tr>
                        })
                    }
                </tbody>
              </table>
            ) : ( null )
          }
        <div className='row pl15 pr15'>
          <span className='line-border mt5 mb0'></span>
        </div>
        <div className="action-form-wrap pt20">
          <div className="box-bottom">
            <Link className="btn-action btn-close" onClick={this.props.onClose}><span>Đóng</span></Link>
          </div>
        </div>
      </Dialog>
    );
  }
}

ChiTietDoiTuongThanhTraDialog.defaultProps = {
  data: {}
}

export default ChiTietDoiTuongThanhTraDialog;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/ChiTietDoiTuongThanhTraDialog.jsx